import { z } from "zod";

export const debtSchemaCreate = z.object({
  isJoint: z.boolean(),
  creditor: z.string(),
  natureOfDebt: z.string().nullish(),
  yearIncurred: z.number().int().min(1900),
  amountDueInCents: z.number(),
  currency: z.string().nullish(),
  userAPercentage: z.number().int().min(0).max(100).nullish(),
  userBPercentage: z.number().int().min(0).max(100).nullish(),
});

export const debtSchemaUpdate = debtSchemaCreate.partial();
